<template>
  <div class="content-main">
    <HeaderBar :text="headerBar.text" :backgroundUrl="headerBar.backgroundUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <img class="dorm-map" :src="`/${$staticPath}/${map}`">
          </div>
          <div class="col-12">
            <div class="detail">
              <p class="head" v-html="address.main"></p>
              <p v-html="address.detail"></p>
              <p><b>{{ tel.main }}</b> : (+66)0-2-4707453</p>
              <p><b>Fax</b> : (+66)0-2-4523455</p>
              <p><b>{{ route.main }}</b> : <a target="_blank" href="https://goo.gl/maps/xPCJ2XV5X7Z79v2G8" rel="noopener noreferrer">{{ route.detail }}</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  props: ['headerBar', 'address', 'tel', 'map', 'route']
}
</script>

<style scoped>

  .content {
    padding: 60px 0 60px 0;
    position: relative;
  }

  .content .contact-map {
    width: 100%;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .content .contact-map img {
    width: 80%;
  }

  .content .detail {
    padding: 30px;
  }

  .detail p.head {
    font-weight: 500;
    font-size: 22px;
  }

  .detail p {
    margin: 0;
  }

  .dorm-map {
    width: 80%;
    background-color: rgba(190, 190, 190, 0.1);
    padding: 15px;
    border: 1px double rgba(180, 180, 180, 0.2);
    border-radius: 40px;
  }

  @media screen and (max-width: 768px) {
    .dorm-map {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DORM/Contact.vue